exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.save-configuration__button::before{display:inline-block;content:\"\";background-image:url(\"/images/outline-heart-configurator-white.svg\");background-size:18px 18px;width:18px;height:18px;-webkit-transform:translateY(3px);transform:translateY(3px);margin-right:10px\n}\n.save-configuration__link{text-align:center;display:block;margin:30px auto\n}\n.save-configuration__link::before{display:inline-block;content:\"\";background-image:url(\"/images/outline-heart-configurator.svg\");background-size:20px 20px;width:20px;height:20px;-webkit-transform:translateY(5px);transform:translateY(5px);margin-right:5px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7450a46c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/configurator/components/SaveConfiguration.vue
// module id = kKOh
// module chunks = 15